import { render } from "./HeaderSilo.vue?vue&type=template&id=1abb1c5b"
import script from "./HeaderSilo.vue?vue&type=script&lang=js"
export * from "./HeaderSilo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__